import { BREAKPOINTS } from "utils/constants";

// Redux
import store from "store";
import { callIdentify } from "store/slices/accountSlice";

// Tracking
import { ampli } from "ampli";
import { AnalyticsBrowser } from "@segment/analytics-next";

/**
 *
 * @param {String} string - String you want to capitalise
 * @returns {String} Capitalised string
 */
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 *
 * @param {Number} width
 */
export function calculateDevice({ width }) {
  const device = {};
  if (width <= BREAKPOINTS.mobile) {
    device.isMobile = true;
  } else if (width < BREAKPOINTS.tablet) {
    device.isTablet = true;
  } else if (width >= BREAKPOINTS.tablet) {
    device.isDesktop = true;
  }
  return { ...device };
}

/**
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Boolean} immediate
 * @returns {Object} object
 */
export function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/**
 *
 * @param {String} id
 */

export function focusLastInputFieldCharacter(id) {
  const inputField = document.getElementById(id).querySelector("input.ds-input-field");

  if (inputField != null && inputField.value.length != 0) {
    if (inputField.createTextRange) {
      let FieldRange = inputField.createTextRange();
      FieldRange.moveStart("character", inputField.value.length);
      FieldRange.collapse();
      FieldRange.select();
    } else if (inputField.selectionStart || inputField.selectionStart == "0") {
      let elemLen = inputField.value.length;
      inputField.selectionStart = elemLen;
      inputField.selectionEnd = elemLen;
      inputField.focus();
    }
  } else {
    inputField?.focus();
  }
}

/**
 *
 * @param {Number} status
 * @param {Boolean} isTemporaryLocked
 */
export function getStatusForAmpli({ isTemporaryLocked, status }) {
  const valueForLockStatus = isTemporaryLocked ? "locked temp" : "permanent lock";
  const AMPLI_STATUS = {
    200: "successful",
    423: valueForLockStatus,
    400: "input error",
    500: "server error",
  };
  return AMPLI_STATUS[status];
}

/**
 * Determines if the provided Object is empty, incase of null/undefined Object, returns true
 * @param {object} obj
 * @returns {Boolean}
 */
export function isEmptyObj(obj) {
  if (!obj) return true;
  return typeof obj === "object" && Object.keys(obj).length === 0;
}

/**
 *
 * @param {Object} params
 */
export function queryParamsBuilder(params) {
  const encode = encodeURIComponent;
  const queryParams = Object.keys(params)
    .map(k => {
      if (!params[k]) return;
      return `${encode(k)}=${encode(params[k])}`;
    })
    .join("&");
  return queryParams;
}

/**
 * @param {String} val
 * @returns {Boolean}
 */
export function validateEmail(val) {
  return val.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,16}$/g);
}

/**
 * @param {String} val
 * @returns {Boolean}
 */
export function validatePassword(val) {
  return val.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{14,}$/g);
}

export function identifyUserInTrackingSystem({ source }) {
  store.dispatch(callIdentify()).then(result => {
    const {
      ampliUserType,
      contact: conNbr,
      contactTypes,
      email: userEmailAddress,
      success,
    } = result.payload;
    const role = contactTypes[0] || "anonymous";
    const userData = { email: userEmailAddress, user_id: conNbr, user_type: ampliUserType };
    if (success) {
      const segment = AnalyticsBrowser.load({
        writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY,
      });

      segment.identify(conNbr, { userEmailAddress, role: role });

      switch (source) {
        case "login-page":
          ampli.loginCompleted(userData);
          break;
        case "password-page":
          ampli.passwordCreated(userData);
          ampli.loginCompleted(userData);
          break;
      }
    }
  });
}
